import React from "react";
// Comment out the logo import for now
// import gptLogo from "../assets/gpt-symbol.png";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="custom-footer">
      <div className="footer-left">
        <a href="/terms" className="footer-link">Terms of Service</a>
        <span className="divider">|</span>
        <a href="/privacy" className="footer-link">Privacy</a>
        <span className="divider">|</span>
        <a href="/contact" className="footer-link">Contact Us</a>
      </div>
      <div className="footer-right">
        <p>© 2025 New U Physical Therapy. All rights reserved.</p>
        <p>
          Designed & Maintained by: <a href="https://www.turiksproduction.com" target="_blank" rel="noopener noreferrer">Turiks Production</a>
          {/* Placeholder for future logo */}
          {/* <img src={gptLogo} alt="GPT Logo" className="footer-logo" /> */}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
